module.exports = __webpack_public_path__ + "static/media/rd-gcbanner-new.518d4dbd.png";